/**
 * Formats a timestamp as a relative time string (e.g., "3d ago", "2h ago").
 * Used for pipeline timestamps (#590).
 */
export function formatRelativeTime(ts: string | null | undefined): string | null {
  if (!ts) return null;
  const ms = Date.now() - new Date(ts).getTime();
  const h = Math.floor(ms / 3_600_000);
  if (h < 1) return "just now";
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  if (d < 30) return `${d}d ago`;
  const m = Math.floor(d / 30);
  return `${m}mo ago`;
}

/**
 * Compact variant for table cells — returns "—" for null instead of null.
 */
export function formatRelativeTimeCompact(ts: string | null | undefined): string {
  return formatRelativeTime(ts) ?? "—";
}
